import axios from 'axios';
import { ConsoleApiKey, ConsoleApiUrl, DisableConsole } from 'Utils/Utils';

const CONSOLE_API_BASE_URL = ConsoleApiUrl();

export const console_api = axios.create({
  baseURL: CONSOLE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 20000,
});

console_api.interceptors.request.use(
  (config) => {
    // Env-gated kill switch (REACT_APP_DISABLE_CONSOLE). Rejecting here means
    // axios never dispatches the request, so this blocks every consoleAPI.*
    // call — not just /console/me — at the network layer. AuthContext's
    // existing catch on getMe() already treats a failed call as "no access",
    // so this alone hides the Sidebar Console button and trips the
    // ConsoleRoute/AdminConsoleRoute redirects with no other code changes.
    if (DisableConsole()) {
      const disabledError: any = new Error('Console is disabled in this environment');
      disabledError.isConsoleDisabled = true;
      throw disabledError;
    }
    const token = ConsoleApiKey();
    if (token) {
      config.headers.set('X-API-Key', token);
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

console_api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error?.isConsoleDisabled) {
      console.error('Response error:', error);
    }

    // Do NOT redirect to /login for /console/* routes.
    // A 401 from /console/me simply means the user doesn't have console access —
    // it is non-fatal and should be handled gracefully by the caller (AuthContext).
    const isConsoleRequest = error.config?.url?.toString().startsWith('/console');
    if (error.response?.status === 401 && !isConsoleRequest) {
      localStorage.removeItem('currentUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
